import script from "./SettingsHomeCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsHomeCard.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsHomeCard.vue?vue&type=style&index=0&id=6530732c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6530732c"]])

export default __exports__